module.exports = __webpack_public_path__ + "img/face.a6a36fca.svg";